

import React, { useState } from "react";

export default function TreeHole() {
  const [title, setTitle] = useState("");
  const [contact, setContact] = useState("");
  const [content, setContent] = useState("");
  const [status, setStatus] = useState("");

  const webhook = "https://ding.lin8177.top"; // TODO: Replace with your webhook

  const submit = async () => {
    if (!title || !content) {
      setStatus("标题和内容不能为空");
      return;
    }

    setStatus("提交中...");

    try {
      const res = await fetch(webhook, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          msgtype: "markdown",
          markdown: {
            title: title,
            text: `# 🌲 树洞提交\n\n**标题：** ${title}\n\n**联系方式：** ${contact || "无"}\n\n---\n${content}\n\n> 🕒 ${new Date().toLocaleString()}`
          }
        }),
      });

      if (res.ok) {
        setStatus("提交成功！");
        setTitle("");
        setContact("");
        setContent("");
      } else {
        setStatus("提交失败，请稍后再试");
      }
    } catch (err) {
      setStatus("网络错误，请检查网络");
    }
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>树洞</h2>

      <input
        placeholder="标题"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        style={styles.input}
      />

      <input
        placeholder="联系方式（可选）"
        value={contact}
        onChange={(e) => setContact(e.target.value)}
        style={styles.input}
      />

      <textarea
        placeholder="写点什么吧..."
        value={content}
        onChange={(e) => setContent(e.target.value)}
        style={styles.textarea}
      />

      <button onClick={submit} style={styles.button}>提交</button>

      {status && <p style={styles.status}>{status}</p>}
    </div>
  );
}

const styles = {
  container: {
    padding: "20px",
    color: "#fff",
    maxWidth: "600px",
    margin: "0 auto",
  },
  title: {
    textAlign: "center",
    marginBottom: "20px",
    fontSize: "28px",
    fontWeight: "bold",
  },
  input: {
    width: "100%",
    padding: "12px",
    marginBottom: "15px",
    borderRadius: "10px",
    border: "none",
    fontSize: "16px",
  },
  textarea: {
    width: "100%",
    padding: "12px",
    height: "120px",
    borderRadius: "12px",
    border: "none",
    fontSize: "16px",
    marginBottom: "15px",
  },
  button: {
    width: "100%",
    padding: "14px",
    background: "#409eff",
    border: "none",
    borderRadius: "12px",
    fontSize: "18px",
    fontWeight: "bold",
    color: "#fff",
    cursor: "pointer",
  },
  status: {
    marginTop: "15px",
    textAlign: "center",
  },
};